import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';

import { useAuth } from '../context/AuthContext';

/**
 * Login page — auto-redirects to Google OAuth on mount.
 * Renders a brief "Redirecting…" screen so users see something while
 * the round-trip happens.
 */
export default function LoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    } else {
      login();
    }
  }, [user, navigate, login]);

  return (
    <div className="login-page">
      <div className="login-bg" />
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo">
            <img src="/eyvo-logo.png" alt="Eyvo" className="eyvo-logo-img" />
            <span className="logo-text">Procurement</span>
          </div>
          <p className="login-subtitle">SOC 2 Compliance Platform</p>
        </div>

        <div className="login-card">
          <h2>Redirecting to Google...</h2>
          <p>Sign in with your @eyvo.com Google account</p>

          <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
            <div className="loading-spinner" />
          </div>

          <div className="login-divider">
            <Link to="/trust-center" className="trust-link" data-testid="trust-center-link">
              <Globe size={16} />
              View Public Trust Center
            </Link>
          </div>
        </div>

        <p className="client-link">
          Client portal access? <Link to="/client-login">Click here</Link>
        </p>
      </div>
    </div>
  );
}
